export type { FrameLoaderProps } from './iframe-loader';
export { IFrameLoader } from './iframe-loader';
